export { default } from "./CardTopic"
